<div class="projects-grid highlighted-projects">
    <div class="row projects-item">
        <div class="col-lg-6  projects-item-column-1">
            <app-project-item
                    *ngIf="highlightedProjects.length > 0"
                    [project]="highlightedProjects[0]"
            ></app-project-item>
        </div>
        <div class="col-lg-6 projects-item-column-2">
            <div class="row">
                <div class="col-lg-4 d-none d-lg-block">
                    <div class="cta-card d-flex">
                        <a routerLink="/contact" class="innerlink"></a>
                        <h2 class="align-self-center">Want to start a new project?</h2>
                        <i class="fa fa-angle-right" aria-hidden="true"></i>
                    </div>
                </div>
                <div class="col-lg-8">
                    <app-project-item
                            *ngIf="highlightedProjects.length > 1"
                            [project]="highlightedProjects[1]"
                    ></app-project-item>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <app-project-item
                            *ngIf="highlightedProjects.length > 2"
                            [project]="highlightedProjects[2]"
                    ></app-project-item>
                </div>
            </div>
        </div>
    </div>
</div>
<div class="projects-grid">
    <div class="row projects-item"
         *ngFor="let subProjects of projects; let even = even">
        <div class="col-lg-6 projects-item-column-1" [ngClass]="{'order-lg-2': even}">
            <app-project-item
                    *ngIf="subProjects.length > 0"
                    [project]="subProjects[0]"
            ></app-project-item>
        </div>
        <div class="col-lg-6 projects-item-column-2" [ngClass]="{'order-lg-1': even}">
            <app-project-item
                    *ngIf="subProjects.length > 1"
                    [project]="subProjects[1]"
            ></app-project-item>
            <app-project-item
                    *ngIf="subProjects.length > 2"
                    [project]="subProjects[2]"
            ></app-project-item>
        </div>
    </div>
</div>
<div class="row bg-dark-space">
</div>



// WEBPACK FOOTER //
// /Users/tom/Projects/mercit2018/src/app/project/list/list.component.html